
import { KanbanCardDateController } from './kanban-card-date.controller'

function kanbanCardDate () {
  return {
    restrict: 'E',
    scope: {
      task: '<'
    },
    templateUrl: '/workflow/directives/kanban-card-date/kanban-card-date.html?$$REVISION$$',
    controller: KanbanCardDateController
  }
}

export { kanbanCardDate }
